import { getGlobalClassNames } from '../../Styling';
var GlobalClassNames = {
  root: 'ms-ChoiceFieldGroup',
  flexContainer: 'ms-ChoiceFieldGroup-flexContainer'
};
export var getStyles = function getStyles(props) {
  var className = props.className,
      optionsContainIconOrImage = props.optionsContainIconOrImage,
      theme = props.theme;
  var classNames = getGlobalClassNames(GlobalClassNames, theme);
  return {
    // TODO (Fabric 8?) - merge className back into `root` and apply root style to
    // the actual root role=application element
    applicationRole: className,
    root: [classNames.root, theme.fonts.medium, {
      display: 'block'
    }],
    flexContainer: [classNames.flexContainer, optionsContainIconOrImage && {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }]
  };
};